import html2canvas from 'html2canvas'
export const REG_EN = /^[\a-zA-Z0-9]+$/;
export const REG_CH = /^[\u4e00-\u9fa5]+$/; // 中文

//整数
export const REG_INTEGER = /^[1-9]+[0-9]*$/;
//数字
export const REG_NUMBER = /^[1-9]+[0-9]*(\.\d{0,4})?$/;
//十进制
export const REG_DECIMAL = /^0(\.\d{0,4})?$/;
//验证邮箱
export const REG_EMAIL =
	/^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/;
//手机号格式
export const REG_PHONE = /^1[3|4|5|6|7|8|9]\d{9}$/;
//手机邮箱
export const REG_EMAIL_PHONE = /(^[\w.\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$)|(^1[3|4|5|6|7|8|9]\d{9}$)/;


export const REG_URL = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/;
export const REG_ADDR = /^[\w\-\@?^=%&\/~\+#]+[\w,`\-\.\@?^=%&\/~\+#\s]*$/;

export const REG_CH_NAME = /^[\u4e00-\u9fa5·-]+$/;
export const REG_EN_NAME = /^[a-zA-Z]*$/;
export const REG_ID = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
export const REG_CARD_ID = /^\d{16,19}$/;

//支持数字，字母，-和_
export const InvitationCode = /^[\a-zA-Z0-9-_]+$/;

export const REG_EN_UPP = /^[A-Z]*$/;

export const REG_DOMAIN_ROOT = /^(?:[a-zA-Z0-9]+(?:\-*[a-zA-Z0-9])*\.)+[a-zA-Z0-9]{2,63}$/;
//密码
export const REG_PASSWORK = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
//6-20位数字字母组合成的密码
export const REG_NEW_PASSWORK = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/

//数字字母组合
export const REG_number_letter = /^[A-Za-z0-9]+$/

export default {
	//手机号格式
	REG_PHONE(){
		return /^1[3|4|5|6|7|8|9]\d{9}$/
	},
	//6-20位数字字母组合成的密码
	REG_NEW_PASSWORK(){
		return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
	},
	//数字+大写字母的组合
	NumericUppercaseLetters(){
		return /^[A-Z0-9]+$/
	},
	Amount(Amount) {
		Amount = Amount.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
		Amount = Amount.replace(/^\./g, ''); //必须保证第一个为数字而不是. 
		Amount = Amount.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的  
		Amount = Amount.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		Amount = Amount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数  
		if (Amount.indexOf(".") < 0 && Amount != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
			Amount = parseFloat(Amount);
		}
		if (Amount.length > 18) {
			Amount = Amount.substring(0, 18);
		}
		return Amount
	},
	toImage(item) {
			let imageWrapper = item
			var cliewidth = imageWrapper.offsetWidth
			var clieheight = imageWrapper.offsetHeight
			var kh = [cliewidth, clieheight]
	
			html2canvas(imageWrapper).then(canvas => {
				let dataURL = canvas.toDataURL("image/png");
				new Promise(resolve => {
					let canvas = document.createElement('canvas')
					let ctx = canvas.getContext('2d')
					let img = new Image()
					img.crossOrigin = 'Anonymous' //允许跨域
					img.src = dataURL
					img.onload = function() {
						canvas.height = kh[1]
						canvas.width = kh[0]
						ctx.drawImage(img, 0, 0, kh[0], kh[1])
						let dataURL = canvas.toDataURL('image/png')
						canvas = null
						resolve(dataURL)
					}
				}).then(base64 => {
					let link = document.createElement('a')
					link.href = base64
					link.download = 'AccountOpeningLetter.png'
					link.click()
				})
			});
		},
	// 小币种数据
	SmallCurrencyData() {
		let Curdata=[{
			'currency':'IDR'
		},
		{
			'currency':'PHP'
		},
		{
			'currency':'THB'
		},
		{
			'currency':'VND'
		},
		{
			'currency':'MYR'
		},
		{
			'currency':'NGN'
		},
		{
			'currency':'KES'
		},
		{
			'currency':'GHS'
		},
		{
			'currency':'XOF_CI'
		},{
			'currency':'XOF_SN'
		},{
			'currency':'ZAR'
		},
		{
			'currency':'UGX'
		}]
		return Curdata
	},
	//电商平台
	BusinessData() {
		let Businessdata=[{
			'name':'AMAZON',
			'value':'AMAZON'
		},
		{
			'name':'美客多',
			'value':'MERCADO'
		},
		{
			'name':'闪电',
			'value':'LIGHTNING'
		},
		{
			'name':'Jumia（SC）',
			'value':'JUMIA'
		},
		{
			'name':'Takealot',
			'value':'TAKEALOT'
		},
		{
			'name':'Jumia（VC）',
			'value':'JUMIA_VC'
		},
		{
			'name':'LAZADA',
			'value':'LAZADA'
		},
		{
			'name':'SHOPEE',
			'value':'SHOPEE'
		},
		{
			'name':'SHOPIFY',
			'value':'SHOPIFY'
		},
		{
			'name':'TikTok',
			'value':'TIKTOK'
		}]
		return Businessdata
	},
	//所属国家/地区
	CountryData() {
		let CountryData=[{
			'name':'菲律宾',
			'value':'PHILIPPINE'
		},
		{
			'name':'印度尼西亚',
			'value':'IDN'
		},
		{
			'name':'越南',
			'value':'VIETNAM'
		},
		{
			'name':'香港',
			'value':'HKG'
		},
		{
			'name':'马来西亚',
			'value':'MALAYSIA'
		},
		{
			'name':'泰国',
			'value':'THAILAND'
		},
		{
			'name':'美国',
			'value':'USA'
		},
		{
			'name':'日本',
			'value':'Japan'
		},
		{
			'name':'澳大利亚',
			'value':'Australia'
		},
		{
			'name':'英国',
			'value':'United_Kingdom'
		},
		{
			'name':'德国',
			'value':'Germany'
		},
		{
			'name':'法国',
			'value':'France'
		},
		{
			'name':'意大利',
			'value':'Italy'
		},
		{
			'name':'西班牙',
			'value':'Spain'
		},
		{
			'name':'南非',
			'value':'ZAF'
		},
		{
			'name':'荷兰',
			'value':'Netherlands'
		}]
		return CountryData
	},
	// 账户币种
	AccountCurrency() {
		let AccountCurrencydata=[{
		  name:'在岸人民币',
		  value:'CNY'
	  },{
		  name:'港币',
		  value:'HKD'
	  },{
		  name:'美元',
		  value:'USD'
	  },{
		  name:'日元',
		  value:'JPY'
	  },{
		  name:'英镑',
		  value:'GBP'
	  },{
		  name:'欧元',
		  value:'EUR'
	  },{
		  name:'印尼卢比',
		  value:'IDR'
	  },{
		  name:'菲律宾比索',
		  value:'PHP'
	  },{
		  name:'泰铢',
		  value:'THB'
	  },{
		  name:'越南盾',
		  value:'VND'
	  },{
		  name:'马来西亚林吉特',
		  value:'MYR'
	  },{
		  name:'尼日利亚奈拉',
		  value:'NGN'
	  },{
		  name:'肯尼亚先令',
		  value:'KES'
	  },{
		  name:'加纳塞地',
		  value:'GHS'
	  },{
		  name:'科特迪瓦西非法郎',
		  value:'XOF_CI'
	  },{
		  name:'塞内加尔西非法郎',
		  value:'XOF_SN'
	  },{
		  name:'乌干达先令',
		  value:'UGX'
	  },{
		  name:'印度卢比',
		  value:'INR'
	  },{
		  name:'埃及镑',
		  value:'EGP',
	  },{
		  name:'南非兰特',
		  value:'ZAR',
	  },{
		  name:'韩国元',
		  value:'KRW'
	  }]
		return AccountCurrencydata
	},
	// 币种展示
	CurrencyShow() {
		
		let Currencydata=[{
		  name:'在岸人民币|CNY',
		  value:'CNY'
	  },{
		  name:'港币|HKD',
		  value:'HKD'
	  },{
		  name:'美元|USD',
		  value:'USD'
	  },{
		  name:'日元|JPY',
		  value:'JPY'
	  },{
		  name:'英镑|GBP',
		  value:'GBP'
	  },{
		  name:'欧元|EUR',
		  value:'EUR'
	  },{
		  name:'印尼卢比|IDR',
		  value:'IDR'
	  },{
		  name:'菲律宾比索|PHP',
		  value:'PHP'
	  },{
		  name:'泰铢|THB',
		  value:'THB'
	  },{
		  name:'越南盾|VND',
		  value:'VND'
	  },{
		  name:'马来西亚林吉特|MYR',
		  value:'MYR'
	  },{
		  name:'尼日利亚奈拉|NGN',
		  value:'NGN'
	  },{
		  name:'肯尼亚先令|KES',
		  value:'KES'
	  },{
		  name:'加纳塞地|GHS',
		  value:'GHS'
	  },{
		  name:'科特迪瓦西非法郎|XOF_CI',
		  value:'XOF_CI'
	  },{
		  name:'塞内加尔西非法郎|XOF_SN',
		  value:'XOF_SN'
	  },{
		  name:'新台币|TWD',
		  value:'TWD'
	  },{
		  name:'澳大利亚元|AUD',
		  value:'AUD'
	  },{
		  name:'韩国元|KRW',
		  value:'KRW'
	  },{
		  name:'加拿大元|CAD',
		  value:'CAD'
	  },{
		  name:'瑞士法郎|CHF',
		  value:'CHF'
	  },{
		  name:'新加坡元|SGD',
		  value:'SGD'
	  },{
		  name:'离岸人民币|CNH',
		  value:'CNH'
	  },{
		  name:'新西兰币|NZD',
		  value:'NZD'
	  },{
		  name:'坦桑尼亚先令|TZS',
		  value:'TZS'
	  },{
		  name:'沙特里亚尔|SAR',
		  value:'SAR'
	  },{
		  name:'俄罗斯卢布|RUB',
		  value:'RUB'
	  },{
		  name:'乌干达先令|UGX',
		  value:'UGX'
	  },{
		  name:'印度卢比|INR',
		  value:'INR'
	  },{
		  name:'南非兰特|ZAR',
		  value:'ZAR',
	  },{
		  name:'埃及镑|EGP',
		  value:'EGP'
	  }]
		return Currencydata
	},
	// 平台订单状态
	PlatformOrderStatus() {
		let PlatformOrderStatusData=[{
			name:'COMPLETED',
			value:'COMPLETED'
		},{
			name:'TO_CONFIRM_RECEIVE',
			value:'TO_CONFIRM_RECEIVE'
		},{
			name:'DELIVERED',
			value:'DELIVERED'
		},{
			name:'SHIPPED',
			value:'SHIPPED'
		},{
			name:'PROCESSD',
			value:'PROCESSD'
		},{
			name:'WAIT_COLLECTION',
			value:'WAIT_COLLECTION'
		},{
			name:'PACKED',
			value:'PACKED'
		},{
			name:'PENDING',
			value:'PENDING'
		},{
			name:'UNPAID',
			value:'UNPAID'
		},{
			name:'REPACKED',
			value:'REPACKED'
		},{
			name:'READY_TO_SHIP_PENDING',
			value:'READY_TO_SHIP_PENDING'
		},{
			name:'READY_TO_SHIP',
			value:'READY_TO_SHIP'
		},{
			name:'RETRY_SHIP',
			value:'RETRY_SHIP'
		},{
			name:'TO_RETURN',
			value:'TO_RETURN'
		},{
			name:'CANCELLED',
			value:'CANCELLED'
		},{
			name:'PACKAGE_LOST',
			value:'PACKAGE_LOST'
		},{
			name:'PACKAGE_DAMAGED',
			value:'PACKAGE_DAMAGED'
		},
		]
		return PlatformOrderStatusData
	},
	// 输入框只能输入字母和数字
	numberletter(index) {
		if (!REG_number_letter.test(index)) {
		  index=''
		}
		return index
	},
	// 输入框只能输入手机号码
	numberPhone(index) {
		if (!REG_PHONE.test(index)) {
		  index=''
		}
		return index
	},
	IsitEmpty(item){//判断是否为空
		if(item==false||item==null||item==undefined||item.length==0||item==''||JSON.stringify(item) == '{}'){
			return false
		}else{
			return true
		}		
	},
	// 对象通过value找到key
	findKeyByValue(obj, value) {
	  const result = Object.entries(obj).find(([key, val]) => val === value);
	  return result ? result[0] : null;
	}
}
/**
 * 获取uuid
 */
export function getUUID() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
	})
}

import CryptoJS from 'crypto-js'
const key = CryptoJS.enc.Utf8.parse("734e6b616e732b4976735a726377315a"); //十六位十六进制数作为密钥

export function decrypt(word) {
	var key = '734e6b616e732b4976735a726377315a';
	key = CryptoJS.enc.Hex.parse(key)
	// var src = "werty7890";
	// var enc = CryptoJS.AES.encrypt(src ,key,{
	//     mode: CryptoJS.mode.ECB,
	//     padding: CryptoJS.pad.Pkcs7
	// })
	//console.log('加密:',enc.toString());
	// var enced = enc.ciphertext.toString()
	var enced = word
	var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(enced), key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	})
	return CryptoJS.enc.Utf8.stringify(dec)
}

// const KEY = CryptoJS.enc.Utf8.parse('5Axa1WHn27i2PdI6');
// const IV = CryptoJS.enc.Utf8.parse('1234567890abcdef');
// //解密方法
// export function decrypt(word, keyStr, ivStr) {
// 	let key = KEY;
// 	      let iv = IV;
	
// 	      if (keyStr) {
// 	        key = CryptoJS.enc.Utf8.parse(keyStr);
// 	        iv = CryptoJS.enc.Utf8.parse(ivStr);
// 	      }
	
// 	      let base64 = CryptoJS.enc.Base64.parse(word);
// 	      let src = CryptoJS.enc.Base64.stringify(base64);
	
// 	      var decrypt = CryptoJS.AES.decrypt(src, key, {
// 	        iv: iv,
// 	        mode: CryptoJS.mode.CBC,
// 	        padding: CryptoJS.pad.ZeroPadding
// 	      });

// 	      var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
// 	      return decryptedStr.toString();
// }
//加密
export function encrypt(word, keyStr, ivStr) {
	let key = KEY;
	      let iv = IV;
	
	      if (keyStr) {
	        key = CryptoJS.enc.Utf8.parse(keyStr);
	        iv = CryptoJS.enc.Utf8.parse(ivStr);
	      }
	
	      let srcs = CryptoJS.enc.Utf8.parse(word);
	      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
	        iv: iv,
	        mode: CryptoJS.mode.CBC,
	        padding: CryptoJS.pad.ZeroPadding
	      });
	      // console.log("-=-=-=-", encrypted.ciphertext)
	      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

 // //加密
 //    encrypt(word, keyStr) {
 //        keyStr = keyStr ? keyStr : 'abcdsxyzhkj12345'; //判断是否存在ksy，不存在就用定义好的key
 //        var key = CryptoJS.enc.Utf8.parse(keyStr);
 //        var srcs = CryptoJS.enc.Utf8.parse(word);
 //        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
 //        return encrypted.toString();
 //    },
 // * 是否有权限
 // * @param {*} key
 // */
export function isAuth(key) {
	return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

//paraName 等找参数的名称
export　function GetUrlParam(paraName) {
　　　　var url = document.location.toString();
　　　　var arrObj = url.split("?");

　　　　if (arrObj.length > 1) {
　　　　　　var arrPara = arrObj[1].split("&");
　　　　　　var arr;

　　　　　　for (var i = 0; i < arrPara.length; i++) {
　　　　　　　　arr = arrPara[i].split("=");

　　　　　　　　if (arr != null && arr[0] == paraName) {
　　　　　　　　　　return arr[1];
　　　　　　　　}
　　　　　　}
　　　　　　return "";
　　　　}
　　　　else {
　　　　　　return "";
　　　　}
　　}
